module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/buying-small-5375272216517fe47d7448cc4ff30afc.svg";